import React, { Component } from 'react';
import PropTypes from 'prop-types';
import BeneficiaryForm from '../BeneficiaryForm';
import ModalPortal from '../ModalPortal';
import './ModalBeneficiaryDetails.css';

const propTypes = {
  client: PropTypes.object,
  beneficiary: PropTypes.object,
  onSubmit: PropTypes.func,
};

const defaultProps = {
  client: null,
  beneficiary: {},
  onSubmit: () => {},
};

class ModalBeneficiaryDetails extends Component {
  handleSubmit = (e) => {
    e.preventDefault();
    this.props.onSubmit();
  };

  hide() {
    this.beneficiaryForm.reset();
    window.$(this.modal).modal('hide');
  }

  show() {
    window.$(this.modal).modal('show');
  }

  render() {
    const { client, beneficiary, onChange } = this.props;
    return (
      <ModalPortal>
        <div
          className="ModalBeneficiaryDetails modal"
          id="enrollClientModal"
          ref={(c) => (this.modal = c)}
        >
          <div className="modal-dialog modal-lg" role="document">
            <div className="modal-content-wrapper">
              <form className="form" onSubmit={this.handleSubmit}>
                <div className="modal-content">
                  <div className="modal-header">
                    <h5 className="modal-title">Add a beneficiary</h5>
                    <button
                      type="button"
                      className="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div className="modal-body">
                    <BeneficiaryForm
                      client={client}
                      beneficiary={beneficiary}
                      onChange={onChange}
                      ref={(c) => (this.beneficiaryForm = c)}
                    />
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      data-dismiss="modal"
                    >
                      Cancel
                    </button>
                    <button type="submit" className="btn btn-complete">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </ModalPortal>
    );
  }
}

ModalBeneficiaryDetails.propTypes = propTypes;
ModalBeneficiaryDetails.defaultProps = defaultProps;

export default ModalBeneficiaryDetails;
